import React from 'react'
import CircledButtonWithLabel, { LogoVariants } from '../../genericComponents/CircledButtonWithLabel'
import { useSelector } from 'react-redux'
import { selectEmail } from './contactInfo.selectors'
import TagActionButton from '../../genericComponents/TagActionButton'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { SPD_GEOENTITY_EMAIL } from '../../analytics/BiTagger'
import useCommonGeoentityClickTagProps from '../useCommonGeoentityClickTagProps'
import useTagBiForGeoentity from '../useTagBiForGeoentity'

export default function GeoentityEmailButton() {
  const email = useSelector(selectEmail)
  const sendBiTagNow = useTagBiForGeoentity(SPD_GEOENTITY_EMAIL)
  const clickTagProps = useCommonGeoentityClickTagProps(PUB_TAG.PUB_FICHEPOI_EMAIL)

  return (
    <TagActionButton
      onClick={() => {
        sendBiTagNow()
        window.open(`mailto:${email}`)
      }}
      deferClick
      {...clickTagProps}
    >
      <CircledButtonWithLabel
        svgId="arobase"
        label="geoentity.contact_info.email"
        logoVariant={LogoVariants.sharpDarkGreyBorder}
      />
    </TagActionButton>
  )
}
